module.exports = __webpack_public_path__ + "img/WP2023-Reg-advance-1200-1200.d6905130.png";